<template lang="pug">
.d-flex.flex-column.gap-12.d-input-base__container
  .d-flex.flex-column.gap-4.gr-1(
    v-if="(label || description) && !defaultLabel"
  )
    template(v-if="label")
      .d-flex.align-center
        h3(:class="labelClass") {{ label }}
        v-spacer
        p.ui-body-2.ui-neutral--text.opacity-60(v-if="!required") Необязательно
    template(v-if="description")
      p(:class="descriptionClass") {{ description }}
    slot(name="label-append")
  template(v-if="component")
    component(
      :is="component"
      :value="value"
      v-bind="extendAttrs"
      v-on="$listeners"
    )
      template(
        v-for="(_, name) in $scopedSlots"
        v-slot:[name]="data"
      )
        slot(:name="name" v-bind="data")
      template(
        v-for="(_, name) in $slots"
        :slot="name"
      )
        slot(:name="name")
      template(#message="{ key, message }")
        slot(name="message" v-bind="{ key, message }")
          p.ui-body-2
            v-icon.d-inline-block.mr-1(
              v-if="isErrorMessages"
              :size="16"
              color="ui-error"
            ) {{ errorIcon }}
            span {{ message }}
      template(#counter="{ props }")
        slot(name="counter" v-bind="{ props }")
          p.text-right.ui-body-2.ui-neutral--text.opacity-60
            span {{ props.value }}
            template(v-if="props.max")
              span /
              span {{ props.max }}

      template(v-if="!defaultTemplates" #prepend-item)
        slot(name="prepend-item" v-bind="{ title: menuTitle }")
          .pl-4.pr-2.py-3.d-flex.align-center(
            v-if="menuTitle"
          )
            h3.mr-4 {{ menuTitle | upperFirst }}
            //- @TODO: Закрытие через кнопку
            //- dv-btn.ml-auto(
            //-   x-small
            //-   icon
            //-   color="ui-neutral"
            //- ): v-icon(:size="20") $ui-close
      template(v-if="multiple && !defaultTemplates" #item="{ item, on, attrs }")
        dv-checkbox(
          :label="item[extendAttrs.itemText] || item"
          :ripple="false"
          v-bind="attrs"
          hide-details
        )
      template(v-if="multiple && clearable && (value && value.length) && !defaultTemplates" #append-item)
        dv-btn.mt-2(
          color="ui-neutral lighten-4"
          block
          @click="clearList"
        ): p.ui-neutral--text Сбросить

      template(#append-outer)
        slot(name="append-outer")
          p.ui-body-2.ui-neutral--text.opacity-60(
            v-if="postscript"
          )
            span {{ postscript }}

  template(v-else)
    slot
</template>

<script>
import { VIcon } from 'vuetify/lib';
import { BASE_MENU_ATTRS } from '../menus/DvMenu.vue';
import DvBtn from '../buttons/DvBtn.vue';
import DvCheckbox from './DvCheckbox.vue';
import { upperFirst } from 'lodash';

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  filters: {
    upperFirst,
  },
  components: {
    VIcon,
    DvBtn,
    DvCheckbox,
  },
  props: {
    component: { type: [String, Function, Object], default: undefined },
    value: { type: [String, Number, Array, Object], default: undefined },
    label: { type: String, default: null },
    description: { type: String, default: null },
    defaultLabel: { type: Boolean, default: false },
    labelClass: { type: [String, Array], default: '' },
    descriptionClass: { type: [String, Array], default: 'ui-body-2 opacity-60' },
    componentClass: { type: [String, Array], default: '' },
    errorIcon: { type: [String, Object], default: '$ui-attention' },
    errorMessages: { type: Array, default: () => ([]) },
    error: { type: Boolean, default: false },
    successMessages: { type: Array, default: () => ([]) },
    counter: { type: [Boolean, Number, String], default: undefined },
    menuTitle: { type: String, default: null },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    postscript: { type: String, default: undefined },
    maxWidth: { type: Number, default: undefined },
    minWidth: { type: Number, default: undefined },
    defaultTemplates: { type: Boolean, default: false },
  },
  computed: {
    extendAttrs() {
      const {
        error,
        errorMessages,
        successMessages,
        counter,
        hasMessages,
        multiple,
        clearable,
        postscript,
        maxWidth,
        minWidth,
        label,
        defaultLabel,
        $attrs,
      } = this;
      const menuProps = {
        ...BASE_MENU_ATTRS,
        ...($attrs?.['menu-props'] || $attrs?.menuProps || {}),
      };
      delete $attrs?.['menu-props'];
      delete $attrs?.menuProps;
      return {
        placeholder: 'Выберите...',
        outlined: true,
        error,
        errorMessages,
        successMessages,
        dense: true,
        clearIcon: '$ui-close',
        itemValue: $attrs['item-value'] || 'id',
        itemText: $attrs['item-text'] || 'name',
        hideDetails: !hasMessages && !counter,
        counter,
        multiple,
        clearable,
        maxWidth,
        minWidth,
        ...defaultLabel ? {
          label,
        } : {},
        class: [
          'd-input-base',
          !hasMessages ? 'd-input-base--hidden-messages' : '',
          postscript ? 'd-input-base--postscript' : '',
          this.componentClass,
        ].filter(Boolean).join(' '),
        ...$attrs,
        menuProps,
      };
    },
    isErrorMessages() {
      return this.errorMessages?.length || this.error;
    },
    hasMessages() {
      return this.errorMessages?.length || this.successMessages?.length;
    },
  },
  methods: {
    clearList() {
      this.$emit('input', []);
    },
  },
};
</script>

<style lang="scss" scoped>
.d-input-base {
  $max-width: calc(v-bind(maxWidth) * 1px);
  @if $max-width {
    max-width: $max-width;
  }
  $min-width: calc(v-bind(minWidth) * 1px);
  @if $min-width {
    min-width: $min-width;
  }
  &__container {
    @if $max-width {
      max-width: $max-width;
    }
    @if $min-width {
      min-width: $min-width;
    }
  }
  &.v-input {
    border-radius: 8px;
  }
  &:not(.v-input--is-focused):not(.error--text) {
    &::v-deep .v-input__control > .v-input__slot > fieldset {
      border-color: #d2d2d2 !important;
    }
  }
  &:not(.v-input--is-focused).v-input--is-disabled {
    &:deep(.v-input__control > .v-input__slot fieldset) {
      background-color: var(--v-ui-background-base) !important;
    }

    &:deep(input) {
      &::placeholder {
        color: color-mix(in srgb, var(--v-ui-neutral-base) 30%, transparent) !important;
      }
    }
  }
  &::v-deep .v-input__control {
    .v-input__slot {
      margin-bottom: 0px !important;
      border: unset !important;

      & > fieldset {
        border: currentColor solid 1px !important;
      }
      & .v-input__append-inner, .v-input__prepend-inner {
        margin-top: 0px;
        align-self: center;
        z-index: 1;
      }
    }
    .v-text-field__details,
    .v-select__details {
      padding: 0px;
      flex-direction: column;
      row-gap: 8px;
      margin-top: 8px;
      margin-bottom: 0px;
    }
  }

  &--hidden-messages {
    &::v-deep .v-messages {
      display: none !important;
    }
  }

  &--postscript {
    &:deep(.v-input__append-outer) {
      margin-top: 28px !important;
    }
  }

  // Убираем эти некрасивые стрелочки для type="number"
  &::v-deep input::-webkit-outer-spin-button,
  &::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
}
</style>
